class SVGTextAnimations {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Find all sections with SVG animation enabled
    const sections = document.querySelectorAll('[data-svg-animation]:not([data-svg-animation="none"])');
    
    sections.forEach(section => {
      const style = section.dataset.svgAnimation;
      const strongTags = section.querySelectorAll('strong');
      
      strongTags.forEach(strong => {
        this.wrapWithSVG(strong, style);
      });
    });

    // Setup intersection observer
    this.observeAnimations();
  }

  wrapWithSVG(element, style) {
  // Don't wrap if already wrapped
    if (element.closest('.svg-text-wrapper')) return;

    const wrapper = document.createElement('span');
    wrapper.className = 'svg-text-wrapper';
    wrapper.setAttribute('data-svg-style', style);
    
    // Get color and opacity from parent element's data attribute
    const section = element.closest('[data-svg-animation]');
    const customColor = section ? section.dataset.svgColor : null;
    const customOpacity = section ? section.dataset.svgOpacity : 20;
    
    if (customColor && customColor !== '') {
        wrapper.style.setProperty('--svg-color', customColor);
    }
    
    // Set opacity (convert percentage to decimal)
    wrapper.style.setProperty('--svg-opacity', customOpacity / 100);
    
    // Get the SVG markup for this style
    const svgMarkup = this.getSVG(style);
    
    // Wrap the element
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
    wrapper.insertAdjacentHTML('beforeend', svgMarkup);
    }

  getSVG(style) {
  const svgs = {
    // CURVED UNDERLINE (arced UP)
    'underline': `
      <svg class="svg-text-animation" viewBox="0 0 100 12" preserveAspectRatio="none" aria-hidden="true">
        <path d="M2,10 Q50,2 98,10" stroke="currentColor" stroke-width="4" stroke-linecap="round" fill="none" vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // HAND-DRAWN UNDERLINE (your custom SVG)
    'underline-drawn': `
      <svg class="svg-text-animation" viewBox="0 0 1080 218.24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M151.6,122.62c253.48-56.32,832.26-65.15,773.26-6.75-28.91,28.62-191.51-79.23-585.75,4.87" 
              stroke="currentColor" 
              stroke-width="3.5" 
              stroke-linecap="round" 
              stroke-miterlimit="10"
              fill="none" 
              vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // SCRIBBLE UNDERLINE (your custom SVG - FINALLY WORKING!)
    'scribble': `
      <svg class="svg-text-animation" viewBox="0 0 1080 218.24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M104.61,146.58c45.05-27.3,95.14-46.24,146.96-55.65,7.22-1.31,12.28,6.97,7.83,12.81l-33.07,43.45c-4.9,6.44,1.71,15.3,9.26,12.4,91.03-34.91,186.38-58.54,283.17-70.17,6.39-.77,11.05,5.93,8.12,11.66l-14.25,27.89c-3.3,6.47,2.97,13.65,9.83,11.25,150.68-52.61,314.02-68.63,472.03-46.13" 
              stroke="currentColor" 
              stroke-width="7" 
              stroke-linecap="round" 
              stroke-miterlimit="10"
              fill="none" 
              vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // STRAIGHT UNDERLINE
    'underline-straight': `
      <svg class="svg-text-animation" viewBox="0 0 100 10" preserveAspectRatio="none" aria-hidden="true">
        <line x1="0" y1="5" x2="100" y2="5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // CIRCLE OFF (hand-drawn with overlap)
    'circle-off': `
      <svg class="svg-text-animation" viewBox="0 0 650 404.32" preserveAspectRatio="none" aria-hidden="true">
        <path d="M419.72,339.26c-88.61,20.17-184.4,8.13-265.01-33.3-34.31-17.63-68.24-43.76-76.5-80.97-6.17-27.81,3.63-57.45,21.22-80.04,17.59-22.6,42.25-38.93,67.98-51.92,104.43-52.72,234.28-53.58,339.42-2.24,31.88,15.57,62.04,44.08,66.33,80.43,4.62,39.11-25.11,58.51-55.85,77.24-68.58,41.8-156.08,54.14-233.12,29.43" 
              stroke="currentColor" 
              stroke-width="7" 
              stroke-linecap="round" 
              stroke-miterlimit="10"
              fill="none" 
              vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // LASSO (loose circle)
    'lasso': `
      <svg class="svg-text-animation" viewBox="0 0 650 404.32" preserveAspectRatio="none" aria-hidden="true">
        <path d="M419.72,339.26c-88.61,20.17-184.4,8.13-265.01-33.3-34.31-17.63-68.24-43.76-76.5-80.97-20.64-92.98,69.9-137.02,145.93-153.52,42.76-9.28,87.09-12.83,130.8-11.97,46.65.92,113.39,1.27,146.84,36.94,22.19,23.67,30.48,59.51,20.94,90.52-10.86,35.31-41.51,60.72-72.81,80.34-98.37,61.65-219.23,86.49-333.95,68.63" 
              stroke="currentColor" 
              stroke-width="10" 
              stroke-linecap="round" 
              stroke-miterlimit="10"
              fill="none" 
              vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // CLEAN CIRCLE
    'circle-clean': `
      <svg class="svg-text-animation" viewBox="0 0 120 60" preserveAspectRatio="none" aria-hidden="true">
        <ellipse cx="60" cy="30" rx="55" ry="25" fill="none" stroke="currentColor" stroke-width="2" vector-effect="non-scaling-stroke"/>
      </svg>
    `,
    
    // HIGHLIGHT
    'highlight': `
      <svg class="svg-text-animation" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <rect x="0" y="0" width="100" height="100" fill="currentColor"/>
      </svg>
    `
  };

  return svgs[style] || svgs.underline;
}

  observeAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.5) {
          entry.target.classList.add('svg-animated');
          // Optionally unobserve after animation
          // observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.5,
      rootMargin: '0px'
    });

    // Observe all wrapped elements
    document.querySelectorAll('.svg-text-wrapper').forEach(wrapper => {
      observer.observe(wrapper);
    });
  }
}

// Initialize when Shopify sections are loaded
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  // In theme editor, reinit on section changes
  document.addEventListener('shopify:section:load', () => {
    new SVGTextAnimations();
  });
}

// Initialize on page load
new SVGTextAnimations();